import { ContentTabType } from '../../pages/docASR/utils/config';
import { atom } from 'recoil';

const contentTabActiveState = atom<any>({
  key: 'file/contentTabActive',
  default: ContentTabType.introduction,
});

export { contentTabActiveState };
